import PropTypes from "prop-types";
import { P2StepperItem } from "../../P2Stepper/P2StepperItem";
function P2ProgressiveTabs({
  activeStep = 2,
  required = true,
  stepperItems = [],
  ...props
}) {
  return (
    <div className={`polymer_progressive_tab ${props.className}`}>
      {required && (
        <div className="polymer_progressive_tab__required-container">
          <p className="m-0">*</p>
          <label className="m-0">Required mandatory information</label>
        </div>
      )}

      {activeStep <= stepperItems?.length &&
        new Array(activeStep - 1).fill(1).map((e, _index) => {
          return (
            <div key={`completed_section_card_${_index}`}>
              <div
                style={{ marginTop: _index > 0 ? -20 : 0 }}
                className={`polymer_progressive_tab__top polymer_progressive_tab__top-completed `}
              >
                {
                  <div
                    style={{
                      flex: 1,
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 10,
                    }}
                  >
                    <P2StepperItem variant="section_completed" size={40} />
                    {/* <TextDescription title={stepperItems[_index]?.title}/> */}
                    <p className="m-0">{stepperItems[_index]?.title}</p>
                  </div>
                }
              </div>
              <div
                style={{
                  height: 20,
                  borderLeft: 3,
                  borderRight: 3,
                  borderTop: 0,
                  borderBottom: 0,
                  borderStyle: "solid",
                  borderColor: "#64C8C8",
                }}
              />
            </div>
          );
        })}

      <div
        style={{
          marginTop:
            activeStep > 1 && activeStep <= stepperItems?.length ? -20 : 0,
        }}
      >
        <div className={`polymer_progressive_tab__top`}>
          <div
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 10,
            }}
          >
            {activeStep && stepperItems.length > 0 && (
              <P2StepperItem
                variant="section_active"
                size={40}
                step={activeStep.toString()}
              />
            )}
            {props.titleChildren}
          </div>
        </div>
        <div className={`polymer_progressive_tab__bottom`}>
          {props.contentChildren}
        </div>
      </div>
    </div>
  );
}

export default P2ProgressiveTabs;

P2ProgressiveTabs.propTypes = {
  titleChildren: PropTypes.node,
  contentChildren: PropTypes.node,
  activeStep: PropTypes.number,
  required: PropTypes.bool,
  stepperItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      title: PropTypes.string,
    })
  ),
};

P2ProgressiveTabs.defaultProps = {
  activeStep: 1,
  required: true,
  stepperItems: [],
};
